import { render, staticRenderFns } from "./AdsManagerTable.vue?vue&type=template&id=0da5c422"
import script from "./AdsManagerTable.vue?vue&type=script&lang=js"
export * from "./AdsManagerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports